// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"9ae67474","301":"1913de31"}[chunkId] + ".chunk.js";
};